<div id="openExtendsProvider" class="modal fade in" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title mt-0 ng-binding">Registrar proveedor</h5>
        <button type="button" class="close" data-dismiss="modal" (click)="close()">&times;</button>
      </div>
      <app-loading-modal></app-loading-modal>
      <ng-container *ngIf="service_alert.show">
        <div class="alert alert-{{service_alert.class}} alert-dismissible fade show" role="alert">
          <button type="button" class="close" aria-label="Close" (click)="service_alert.show = false">
              <span aria-hidden="true">×</span>
          </button>
          <strong>¡Datos extraídos!, </strong> {{service_alert.message}}
        </div>
      </ng-container>
      <form validate [formGroup]="item" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="form-group col-lg-4">
                  <label>Tipo cliente <span class="required"></span></label>
                  <select class="form-control" id="typeClientSelected" formControlName="type_client">
                    <option *ngFor="let item of typesclient" [value]="item.id">{{ item.description }}</option>
                  </select>
                  <div *ngIf="submitted && f['type_client'].errors">
                    <small class="text-danger" *ngIf="f['type_client'].errors['required']">Campo requerido</small>
                  </div>
                </div>
                <div class="form-group col-lg-4">
                  <label>Tipo documento<span class="required"></span></label>
                  <select class="form-control" formControlName="typedocument_id" (change)="changeTypeDocument()">
                    <option *ngFor="let item of typesdocument" [value]="item.id">{{ item.description }}</option>
                  </select>
                </div>
                <div class="form-group col-lg-4">
                  <label>N° Documento<span class="required"></span>
                    <ng-container *ngIf="typeDocumentSelected != null">
                      <span class="badge badge-info m-l-15"> {{typeDocumentSelected.max_length_document}} dígitos</span>
                    </ng-container>
                  </label>
                  <div class="input-group" *ngIf="typeDocumentSelected != null">
                    <input type="text" class="form-control" id="client_document" formControlName="document" 
                      maxlength="{{typeDocumentSelected.max_length_document}}" numeric required  autofocus>
                    <div class="input-group-append bg-custom" *ngIf="typeDocumentSelected.id == documentRuc.id">
                      <div class="input-group-text pointer btn-sunat" (click)="extractRuc()" data-toggle="tooltip"
                        data-placement="right" data-original-title="Extraer de Sunat"></div>
                    </div>
                    <div class="input-group-append bg-custom" *ngIf="typeDocumentSelected.id == documentDni.id">
                      <div class="input-group-text pointer btn-reniec" (click)="extractDni()" data-toggle="tooltip"
                        data-placement="right" data-original-title="Extraer de Reniec"></div>
                    </div>
                  </div>
                  <div *ngIf="submitted && f['document'].errors">
                    <small class="text-danger" *ngIf="f['document'].errors['required']">Campo requerido</small>
                  </div>
                </div>
                <div class="form-group col-lg-12">
                  <label>Nombre ó Razón Social<span class="required"></span></label>
                  <input type="text" id="client_fullname" class="form-control text-uppercase" formControlName="fullname"
                    required>
                  <div *ngIf="submitted && f['fullname'].errors">
                    <small class="text-danger" *ngIf="f['fullname'].errors['required']">Campo requerido</small>
                  </div>
                </div>
                <div class="form-group col-lg-12">
                  <label>Nombre comercial</label>
                  <input type="text" id="client_tradename" formControlName="tradename"
                    class="form-control text-uppercase">
                </div>
                <div class="form-group col-lg-4">
                  <label>Departamento <span *ngIf="required_ubigeo" class="required"></span></label>
                  <select class="form-control" [(ngModel)]="departmentSelected" (change)="changeDepartment()"
                    [ngModelOptions]="{standalone: true}">
                    <option value="0">Seleccione</option>
                    <option *ngFor="let item of departments" [value]="item.code">{{ item.name }}</option>
                  </select>
                </div>
                <div class="form-group col-lg-4">
                  <label>Provincias<span *ngIf="required_ubigeo" class="required"></span></label>
                  <select class="form-control" [(ngModel)]="provinceSelected" (change)="changeProvince()"
                    [ngModelOptions]="{standalone: true}">
                    <option value="null">Seleccione</option>
                    <ng-container *ngIf="provinces.length > 0">
                      <option *ngFor="let item of provinces" [value]="item.code">{{ item.name }}</option>
                    </ng-container>
                  </select>
                </div>
                <div class="form-group col-lg-4">
                  <label>Distritos <span *ngIf="required_ubigeo" class="required"></span></label>
                  <select class="form-control" id="districtSelected" formControlName="ubigeo">
                    <option value="null">Seleccione</option>
                    <ng-container *ngIf="districts.length > 0">
                      <option *ngFor="let item of districts" [value]="item.code">{{ item.name }}</option>
                    </ng-container>
                  </select>
                </div>
                <div class="form-group col-lg-12">
                  <label>Dirección</label>
                  <textarea class="form-control no-resize" rows="1" formControlName="address"></textarea>
                </div>
                <div class="form-group col-lg-4">
                  <label>Celular</label>
                  <input type="text" class="form-control" formControlName="cellphone">
                </div>
                <div class="form-group col-lg-4">
                  <label>Teléfono fijo</label>
                  <input type="text" class="form-control" formControlName="telephone">
                </div>
                <div class="form-group col-lg-4">
                  <label>Correo electrónico</label>
                  <input type="email" class="form-control" formControlName="email">
                </div>               
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary close-btn" data-dismiss="modal" (click)="close()">Cancelar</button>
          <button type="submit" class="btn btn-primary">
            <i class="far fa-save m-r-5"></i>
            Guardar
            <ng-container *ngIf="isEdit">
              Cambios
            </ng-container>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
